import { render, staticRenderFns } from "./YellowButton.vue?vue&type=template&id=3e1894b5&scoped=true&"
import script from "./YellowButton.vue?vue&type=script&lang=js&"
export * from "./YellowButton.vue?vue&type=script&lang=js&"
import style0 from "./YellowButton.vue?vue&type=style&index=0&id=3e1894b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1894b5",
  null
  
)

export default component.exports